<template>
    <div class="my-container">
        <!-- Cards de Resumo no topo - mesmo estilo do InvoiceList -->
        <div class="row">
            <div class="col-lg-12" style="padding: 0px;">
                <div class="card-content" style="margin: 0px;padding-left: 18px;padding-right: 18px;padding-bottom: 0px;">
                    <div class="financial-dashboard" v-if="!loading">
                        <div class="dashboard-cards-container">
                            <!-- Card Valor Pago -->
                            <div class="debt-card paid-card">
                                <div class="card-title">
                                    <font-awesome-icon :icon="['fas', 'check-circle']" />
                                    Valor Pago
                                </div>
                                <div class="debt-content">
                                    <div class="debt-count">{{ counters.pagosTotal }}</div>
                                    <div class="debt-amount">Total do período</div>
                                </div>
                            </div>

                            <!-- Card A Vencer -->
                            <div class="debt-card pending-card">
                                <div class="card-title">
                                    <font-awesome-icon :icon="['fas', 'hourglass-half']" />
                                    A Vencer
                                </div>
                                <div class="debt-content">
                                    <div class="debt-count">{{ counters.emDiaTotal }}</div>
                                    <div class="debt-amount">Total do período</div>
                                </div>
                            </div>

                            <!-- Card Atrasado -->
                            <div class="debt-card overdue-card">
                                <div class="card-title">
                                    <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
                                    Atrasado
                                </div>
                                <div class="debt-content">
                                    <div class="debt-count">{{ counters.atrasadosTotal }}</div>
                                    <div class="debt-amount">Total do período</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Loading state para os cards -->
                    <div class="financial-dashboard loading-state" v-if="loading">
                        <div class="loading-card">
                            <div class="loading-content">
                                <div class="loading-spinner">
                                    <font-awesome-icon :icon="['fas', 'spinner']" spin />
                                </div>
                                <h6 class="loading-text">Carregando Resumo Financeiro...</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Card principal com gráfico -->
        <div class="">
            <div class="my-card">
                <!-- Card Header com degradê -->
                <div class="card-header-gradient">
                    <h5 class="card-title">
                        <font-awesome-icon :icon="['fas', 'chart-bar']" />
                        Análise Financeira por Período
                    </h5>
                    <button class="btn-collapse" @click="filtersCollapsed = !filtersCollapsed">
                        <font-awesome-icon :icon="['fas', filtersCollapsed ? 'chevron-down' : 'chevron-up']" />
                        {{ filtersCollapsed ? 'Mostrar Filtros' : 'Ocultar Filtros' }}
                    </button>
                </div>

                <!-- Seção de Filtros dentro do collapse -->
                <div class="filters-collapse" :class="{ collapsed: filtersCollapsed }">
                    <div class="filters-section">
                        <div class="filter-group">
                            <label class="filter-label">Data Inicial</label>
                            <input type="date" class="date-input" v-model="dateInicial" />
                        </div>
                        <div class="filter-group">
                            <label class="filter-label">Data Final</label>
                            <input type="date" class="date-input" v-model="dateFinal" />
                        </div>
                        <div class="filter-group">
                            <button class="btn-apply-filter" @click="getChartData">
                                <font-awesome-icon :icon="['fas', 'search']" /> Buscar
                            </button>
                        </div>
                        <div class="filter-group">
                            <button class="btn-clear-filters" @click="clearFilters">
                                <font-awesome-icon :icon="['fas', 'times']" /> Limpar Filtros
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Card Body com o gráfico -->
                <div class="card-body">
                    <!-- Info e Legenda -->
                    <div class="chart-info" v-if="!loading">
                        <font-awesome-icon :icon="['fas', 'info-circle']" />
                        Você pode ocultar barras do gráfico clicando na legenda abaixo.
                    </div>

                    <div class="chart-legend" v-if="!loading">
                        <div class="legend-item clickable" @click="ocultarPagos">
                            <div class="legend-color paid-color"></div>
                            <span :class="bar_data.data.datasets[0].hidden ? 'legend-disabled' : ''">Pagos</span>
                        </div>
                        <div class="legend-item clickable" @click="ocultarAVencer">
                            <div class="legend-color pending-color"></div>
                            <span :class="bar_data.data.datasets[1].hidden ? 'legend-disabled' : ''">A Vencer</span>
                        </div>
                        <div class="legend-item clickable" @click="ocultarAtrasado">
                            <div class="legend-color overdue-color"></div>
                            <span :class="bar_data.data.datasets[2].hidden ? 'legend-disabled' : ''">Atrasado</span>
                        </div>
                    </div>

                    <!-- Gráfico -->
                    <div class="chart-container" v-if="!loading">
                        <vue3-chart-js :id="'id'" ref="chartRef" :type="'bar'" :data="bar_data.data"
                            :options="bar_data.options" :height="400">
                        </vue3-chart-js>
                    </div>

                    <!-- Loading State -->
                    <div class="loading-container" v-if="loading">
                        <font-awesome-icon :icon="['fas', 'spinner']" spin size="3x" />
                        <p class="mt-3">Carregando dados...</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Bar from "./Charts/Financial/Bar.vue";
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";

export default {
    components: {
        Bar,
        Vue3ChartJs,
    },
    data() {
        return {
            counters: {
                pagosTotal: 0,
                emDiaTotal: 0,
                atrasadosTotal: 0
            },
            delayed: false,
            is_first_click: 1,
            loading: false,
            filtersCollapsed: false,
            dateInicial: new Date().toISOString().substr(0, 10),
            dateFinal: new Date().toISOString().substr(0, 10),
            bar_data: {
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: "Pagos",
                            backgroundColor: ["#27AE60"],
                            data: [],
                            datalabels: {
                                color: "yellow",
                            },
                        },
                        {
                            label: "A Vencer",
                            backgroundColor: ["#2a4a80"],
                            data: [],
                            datalabels: {
                                color: "blue",
                            },
                        },
                        {
                            label: "Atrasado",
                            backgroundColor: ["#C70039"],
                            data: [],
                            datalabels: {
                                align: "end",
                                color: "black",
                                labels: {
                                    title: {
                                        font: {
                                            weight: "bold",
                                        },
                                    },
                                },
                            },
                        },
                    ],
                },
                options: {
                    animation: {
                        onComplete: () => {
                            this.delayed = true;
                        },
                        delay: (context) => {
                            let delay = 0;
                            if (context.type === 'data' && context.mode === 'default' && !this.delayed) {
                                delay = context.dataIndex * 200 + context.datasetIndex * 100;
                            }
                            return delay;
                        },
                    },
                    maintainAspectRatio: false,
                    interaction: {
                        mode: 'point'
                    },
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            margin: 10,
                            padding: 10,
                            position: 'average',
                            intersect: true,
                            callbacks: {
                                label: function (context) {
                                    return (
                                        context.dataset.label + ": R$ " + context.formattedValue
                                    );
                                },
                            },
                        },
                    },
                    responsive: true,
                    scales: {
                        x: {
                            stacked: true,
                        },
                        y: {
                            stacked: true,
                        },
                    },
                },
            },
        };
    },
    methods: {
        formatCurrency(value) {
            if (!value && value !== 0) return 'R$ 0,00';
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },
        
        clearFilters() {
            this.dateFinal = new Date();
            this.dateFinal.setDate(this.dateFinal.getDate() + 365);
            this.dateFinal = this.dateFinal.toISOString().substr(0, 10);

            this.dateInicial = new Date();
            this.dateInicial.setDate(this.dateInicial.getDate() - 365);
            this.dateInicial = this.dateInicial.toISOString().substr(0, 10);
            
            this.getChartData();
        },
        
        ocultarPagos() {
            this.firstClick();
            this.bar_data.data.datasets[0].hidden =
                !this.bar_data.data.datasets[0].hidden;
            this.$refs.chartRef.update();
        },
        
        ocultarAVencer() {
            this.firstClick();
            this.bar_data.data.datasets[1].hidden =
                !this.bar_data.data.datasets[1].hidden;
            this.$refs.chartRef.update();
        },
        
        ocultarAtrasado() {
            this.firstClick();
            this.bar_data.data.datasets[2].hidden =
                !this.bar_data.data.datasets[2].hidden;
            this.$refs.chartRef.update();
        },
        
        firstClick() {
            if (this.is_first_click == 1) {
                this.bar_data.data.datasets[0].hidden = true;
                this.bar_data.data.datasets[1].hidden = true;
                this.bar_data.data.datasets[2].hidden = true;
            }

            this.is_first_click++;

            if (this.is_first_click > 3) {
                this.is_first_click = 1;
            }
        },
        
        getChartData() {
            let self = this;
            self.loading = true;

            const api = self.$store.state.api + "invoices/dashboard?";
            axios
                .get(api, {
                    params: {
                        initialDate: self.dateInicial,
                        finalDate: self.dateFinal,
                    },
                })
                .then((response) => {
                    self.counters.emDiaTotal = response.data.emDiaTotal;
                    self.counters.atrasadosTotal = response.data.atrasadosTotal;
                    self.counters.pagosTotal = response.data.pagosTotal;
                    self.bar_data.data.labels = response.data.labels;
                    self.bar_data.data.datasets[0].data = response.data.pagosList;
                    self.bar_data.data.datasets[0].datalabels = {
                        anchor: 'false',
                        clamp: true,
                        borderColor: 'white',
                        color: '#353536',
                        font: {
                            size: 13
                        },
                        formatter: function (value, context) {
                            if (value != 0) {
                                return (
                                    parseFloat(value).toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    })
                                );
                            } else {
                                return "";
                            }
                        },
                    };
                    self.bar_data.data.datasets[1].data = response.data.emDiaLista;
                    self.bar_data.data.datasets[1].datalabels = {
                        color: "#0d0d0d",
                        anchor: 'false',
                        clamp: true,
                        font: {
                            size: 13
                        },
                        formatter: function (value, context) {
                            if (value != 0) {
                                return (
                                    parseFloat(value).toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    })
                                );
                            } else {
                                return "";
                            }
                        },
                    };
                    self.bar_data.data.datasets[2].data = response.data.atrasadosLista;
                    self.bar_data.data.datasets[2].datalabels = {
                        color: "#0d0d0d",
                        anchor: 'false',
                        clamp: true,
                        font: {
                            size: 13,
                        },
                        formatter: function (value, context) {
                            if (value != 0) {
                                return (
                                    parseFloat(value).toLocaleString("pt-br", {
                                        style: "currency",
                                        currency: "BRL",
                                    })
                                );
                            } else {
                                return "";
                            }
                        },
                    };
                })
                .then(() => {
                    self.loading = false;
                })
                .catch(() => {
                    self.loading = false;
                    self.$toast.error("Erro ao carregar dados financeiros");
                });
        },
    },
    mounted() {
        this.dateFinal = new Date();
        this.dateFinal.setDate(this.dateFinal.getDate() + 365);
        this.dateFinal = this.dateFinal.toISOString().substr(0, 10);

        this.dateInicial = new Date();
        this.dateInicial.setDate(this.dateInicial.getDate() - 365);
        this.dateInicial = this.dateInicial.toISOString().substr(0, 10);

        this.getChartData();
    },
};
</script>

<style scoped>
/* Container Principal - Mesmo padrão do InvoiceList */
.my-container {
    padding: 16px;
    background: #f8f9fa;
    min-height: 100vh;
    width: 100%;
}

.my-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    border: 1px solid #e9ecef;
}

.card-content {
    padding: 20px 24px;
    width: 100% !important;
}

/* Dashboard Financeiro - Cards no topo */
.financial-dashboard {
    width: 100% !important;
    margin-bottom: 12px;
    padding: 0;
}

.dashboard-cards-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    align-items: stretch;
}

/* Cards de Débitos - Mesmo estilo do InvoiceList */
.debt-card {
    background: white;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border-left: 3px solid;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 10px;
    height: 100%;
}

.debt-card:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.debt-card::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    background: linear-gradient(45deg, rgba(0, 0, 0, 0.05), transparent);
    border-radius: 50%;
    transform: translate(15px, -15px);
}

.paid-card {
    border-left-color: #27AE60;
}

.pending-card {
    border-left-color: #2a4a80;
}

.overdue-card {
    border-left-color: #C70039;
}

.debt-card .card-title {
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    line-height: 1;
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
}

.debt-card .card-title i {
    font-size: 14px;
}

.debt-content {
    display: flex;
    flex-direction: column;
    gap: 1px;
    flex: 1;
    width: 100%;
    justify-content: center;
}

.debt-count {
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
}

.debt-amount {
    font-size: 11px;
    font-weight: 500;
    opacity: 0.8;
    line-height: 1.2;
}

.paid-card .debt-count {
    color: #27AE60;
}

.pending-card .debt-count {
    color: #2a4a80;
}

.overdue-card .debt-count {
    color: #C70039;
}

/* Card Header com Degradê */
.card-header-gradient {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 20px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: none;
}

.card-title {
    margin: 0;
    color: white;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 10px;
}

.card-header-gradient .card-title i {
    font-size: 20px;
}

.btn-collapse {
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: white;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-collapse:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-1px);
}

/* Filtros com Collapse */
.filters-collapse {
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    max-height: 500px;
    overflow: hidden;
    transition: max-height 0.3s ease, padding 0.3s ease;
    padding: 20px 24px;
}

.filters-collapse.collapsed {
    max-height: 0;
    padding: 0 24px;
}

.filters-section {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    align-items: end;
}

.filter-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.filter-label {
    font-size: 13px;
    font-weight: 600;
    color: #495057;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.date-input {
    padding: 8px 12px;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    font-size: 14px;
    transition: all 0.3s ease;
    background: white;
}

.date-input:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.btn-apply-filter {
    background: #667eea;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    margin-top: auto;
}

.btn-apply-filter:hover {
    background: #5a67d8;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.btn-clear-filters {
    background: #dc3545;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    margin-top: auto;
}

.btn-clear-filters:hover {
    background: #c82333;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

/* Card Body */
.card-body {
    padding: 24px;
}

/* Chart Info e Legenda */
.chart-info {
    background: #E3F2FD;
    color: #1976D2;
    padding: 12px 16px;
    border-radius: 6px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
}

.chart-legend {
    display: flex;
    justify-content: center;
    gap: 2rem;
    margin-bottom: 20px;
}

.legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    transition: opacity 0.3s;
    font-size: 14px;
}

.legend-item:hover {
    opacity: 0.8;
}

.legend-color {
    width: 40px;
    height: 15px;
    border-radius: 3px;
}

.paid-color {
    background-color: #27AE60;
}

.pending-color {
    background-color: #2a4a80;
}

.overdue-color {
    background-color: #C70039;
}

.legend-disabled {
    text-decoration: line-through;
    opacity: 0.5;
}

.chart-container {
    position: relative;
    height: 400px;
    width: 100%;
}

/* Loading States */
.loading-state {
    margin-bottom: 12px;
}

.loading-card {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 10px;
    padding: 20px 16px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.loading-spinner {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea, #764ba2);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
}

.loading-text {
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
    margin: 0;
}

.loading-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    color: #64748B;
}

.clickable {
    cursor: pointer;
}

/* Responsividade */
@media (max-width: 768px) {
    .my-container {
        padding: 12px;
    }
    
    .card-content {
        padding: 16px 20px;
    }
    
    .dashboard-cards-container {
        grid-template-columns: 1fr;
        gap: 12px;
    }
    
    .filters-section {
        grid-template-columns: 1fr;
    }
    
    .card-header-gradient {
        flex-direction: column;
        gap: 12px;
        align-items: stretch;
    }
    
    .btn-collapse {
        width: 100%;
        justify-content: center;
    }
    
    .debt-card {
        padding: 12px;
    }
    
    .chart-legend {
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }
}

@media (max-width: 576px) {
    .my-container {
        padding: 8px;
    }
    
    .card-content {
        padding: 12px 16px;
    }
    
    .card-title {
        font-size: 16px;
    }
    
    .debt-count {
        font-size: 16px;
    }
    
    .debt-amount {
        font-size: 11px;
    }
}
</style>